// @ts-strict-ignore
import { RedeemCode } from 'mytours-read-api-typescript'
import { Collection, CouponCode } from 'mytours-read-common'
import { getCurrentLanguage, getDataFromLocalStorage, setDataToLocalStorage } from '../platform'
import { DEFAULT_APP_INFO } from '../settings/functions'

export async function saveCouponCodeToDisk(projectId: string, couponCode: CouponCode): Promise<void> {
	const key = projectId + '_coupon_codes'

	const codes = (await getDataFromLocalStorage(key, true)) || []
	const couponCodeIndex = codes.findIndex(
		item =>
			item.code === couponCode.code &&
			item.linkedId === couponCode.linkedId &&
			item.linkedType === couponCode.linkedType,
	)
	if (couponCodeIndex === -1) {
		codes.push(couponCode)
	} else {
		codes[couponCodeIndex] = couponCode
	}

	return setDataToLocalStorage(key, codes, true)
}

export function loadCouponCodesFromDisk(projectId: string): Promise<CouponCode[] | undefined> {
	const key = projectId + '_coupon_codes'
	return getDataFromLocalStorage(key, true)
}

export async function removeCouponCodeFromDisk(projectId: string, couponCode: CouponCode): Promise<void> {
	const key = projectId + '_coupon_codes'

	const codes = (await getDataFromLocalStorage(key, true)) || []
	const couponCodeIndex = codes.findIndex(item => item.code === couponCode.code)

	if (couponCodeIndex !== -1) {
		codes.splice(couponCodeIndex, 1)
	}

	return setDataToLocalStorage(key, codes, true)
}

const getCodes = async (linkedId: number, linkedType: RedeemCode.LinkedTypeEnum): Promise<CouponCode[]> => {
	const codes = (await loadCouponCodesFromDisk(DEFAULT_APP_INFO.projectId)) || []

	return codes.filter(code => code?.linkedId === linkedId && code?.linkedType === linkedType)
}

export const validateAppCode = async (
	validateCode: (couponCode: CouponCode, linkedId: number) => void,
): Promise<void> => {
	const codes = await getCodes(Number(DEFAULT_APP_INFO.appId), RedeemCode.LinkedTypeEnum.App)

	if (codes.length > 0) {
		validateCode(codes[0], Number(DEFAULT_APP_INFO.appId))
	}
}

export const validateCollectionCode = async (
	collection: Collection,
	validateCode: (couponCode: CouponCode, linkedId: number) => void | Promise<boolean>,
): Promise<void | boolean> => {
	if (!collection) {
		return
	}

	const codes = await getCodes(collection.id, RedeemCode.LinkedTypeEnum.Collection)

	if (codes.length > 0) {
		const isValid = await validateCode(codes[0], collection.id)
		if (typeof isValid === 'boolean') {
			return isValid
		}
	} else {
		return false
	}
}

export const formatCurrency = (currency: string, amount: number) => {
	const formatter = new Intl.NumberFormat(getCurrentLanguage(), {
		style: 'currency',
		currency,
	})

	return formatter.format(amount)
}
